import { normalizeString } from '../../functions';

const TransactionStatus = ({
  id,
  value,
  amount,
}) => {
  let displayValue = value;

  if (value === 'processing') displayValue = 'Processing';
  else if (value === 'error') displayValue = 'Error';
  else if (value === 'success') displayValue = '';

  return normalizeString({ data: displayValue, actions: ['capitalize'] });
};

export default TransactionStatus;
